/*global
    aap
*/
(function($){

    'use strict';

    var $form = $('#edit-form'),
        $editPet = $('.edit-pet'),
        $editable = $editPet.find('.editable');

    $editable.each(function() {
        var $this = $(this);

        if(!$this.text()) {
            $this.text('Click to Add');
        }
    });

    $.ajaxSetup({
        headers:{
            'X-CSRF-TOKEN': $form.find('input[name="_token"]').val()
        }
    });

    function update(data, $this) {
        var elValue = data.fields.length ? data.fields[0].value : '';

        if(data.status === 'success') {
            $this.val(elValue);
            if($this.get(0).type === 'text') {
                $this.siblings('.editable').text(elValue).show();
                $this.siblings('.error').hide();
                $this.hide();
            }

            if($this.get(0).nodeName === 'TEXTAREA') {
                $this.siblings('.editable').text(elValue).show();
                $this.siblings('.counter').hide();
                $this.hide();
            }
            return;
        }
        $this.siblings('.error').show();
    }

    function postIt(e) {
        e.stopPropagation();
        /*jshint validthis: true */
        var $this = $(this),
            url = $this.data('url'),
            isCheckbox = $this.get(0).type === 'checkbox' && !$this.is(':checked'),
            checkboxData = aap.stringformat('{0}=0',this.name), // jquery doesn't serialize unchecked checkboxes
            formData = isCheckbox ? checkboxData : $this.serialize();

        function ajaxUpdate(data) {

            if(data) {
                var ml = [],
                    options = function(item) {
                        ml.push(aap.stringformat('<option>{0}, {1}</option>', item.city, item.state));
                    };

                data.matches.forEach(options);
                $('.city-state').html(ml.join(''));
            }

            var xhr = $.ajax({
                url: url,
                type: $form.attr('method'),
                data: formData,
                dataType: 'json',
                cache: false,
                processData: false
            });



            xhr.done(function(data) { update(data, $this); });
        }

        function showError() {
        }

        if(this.name === 'zip') {
            var validationURL = aap.stringformat('{0}?zipcode={1}', $this.data('validation'), $this.val());
            $.get(validationURL).done(ajaxUpdate).fail(showError);
            return;
        }

        ajaxUpdate();
    }

    function editInPlace() {
        /*jshint validthis: true */
        var $this = $(this).hide(),
            $input = $this.parents('tr').find('input').show();

        if($this.hasClass('area')) {
            $input = $this.parents('tr').find('textarea').show();
            $input.siblings('.counter').show();
        }
        $input.on('blur', postIt);
    }

    function setPhotoOrder() {
        /*jshint validthis: true */
        $(this).parents('.order-div').find('input').on('blur', postIt).trigger('blur');
    }

    $editable.on('click', editInPlace);
    $editPet.find('select').on('change', postIt);
    $editPet.find('.checkbox').on('click', postIt);
    $editPet.find('.gallery img').on('click', setPhotoOrder);


}(jQuery));
